import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient} from '@angular/common/http';
import localeEnDk from '@angular/common/locales/en-DK';
import { registerLocaleData } from '@angular/common';


registerLocaleData(localeEnDk, 'en-DK');

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

